import styled from "@emotion/styled";
import { margin as PolishedMargin } from "polished";
import React from "react";

import { CoreLink } from "@brexhq/next/src/components/shared/Link/CoreLink";
import {
  ButtonMargins,
  UnstyledLinkProps,
} from "@brexhq/next/src/components/shared/Link/types";

//unstyling what corelink already has styled.
const UnStyledCoreLink = styled(CoreLink, {
  shouldForwardProp: (prop) => prop !== "margin",
})<{ margin: ButtonMargins }>(({ margin }) => {
  return {
    textDecoration: "unset",
    color: "unset",
    display: "inline-block",
    ...PolishedMargin(...margin),
    "&:hover": {
      textDecoration: "unset",
      color: "unset",
    },
  };
});

export const UnstyledLink = React.forwardRef<
  HTMLAnchorElement,
  UnstyledLinkProps
>(function UnstyledLinkProps(
  {
    to,
    label,
    target,
    rel,
    children,
    margin = [0, 0, 0, 0],
    prefetch,
    ...defaultProps
  },
  ref,
) {
  return (
    <UnStyledCoreLink
      ref={ref}
      margin={margin}
      to={to}
      target={target}
      rel={rel}
      prefetch={prefetch}
      {...defaultProps}
    >
      {children ?? label}
    </UnStyledCoreLink>
  );
});
